
import { Component, Prop, Vue } from 'vue-property-decorator';
import SignDefinition from '@/repositories/data/SignDefinition';
import SignLocationImage from '@/components/SignLocationImage.vue';
import MainSignDetails from '@/components/MainSignDetails.vue';
import SignShapeImage from '@/components/SignShapeImage.vue';

@Component({
    components: { SignShapeImage, MainSignDetails, SignLocationImage },
})
export default class GesturePositionCard extends Vue {
    @Prop({ required: true }) public readonly signDefinition!: SignDefinition;

    get hasTwoRows(): boolean {
        return [
            this.signDefinition.leftHandShape,
            this.signDefinition.rightHandShape,
            this.signDefinition.nextLeftHandShape,
            this.signDefinition.nextRightHandShape,
        ].filter(Boolean).length > 2;
    }

    get hasHandShapes(): boolean {
        return !!(
            this.signDefinition.leftHandShape ||
            this.signDefinition.rightHandShape ||
            this.signDefinition.nextLeftHandShape ||
            this.signDefinition.nextRightHandShape
        );
    }
}
